import Vue from "vue";

import { logger } from "@/app/shared/services/app-logger/app-logger";

Vue.config.errorHandler = (err, vm, info) => {
  Vue.notify({
    group: "main",
    type: "error",
    title: "Une erreur est survenue, veuillez réessayer plus tard.",
    duration: 5000
  });
};

// window.onerror = function(message, source, lineno, colno, error) {
//   logger.logToServer({ message, source, lineno, colno, error });
// };
